import React, { useContext } from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
import { Container } from "reactstrap";
import AdminFooter from "../../components/Footers/AdminFooter";
import Sidebar from "../../components/Sidebar/Sidebar";
import "./Admin.css";
import { routesOffice } from "../../routes.js";
import { AuthContext } from "../../context/AuthContext";
import LogoutTimer from "../../components/LogoutTimer/LogoutTimer";

const Admin = (props: any) => {
  const mainContent = React.useRef(null);
  const location = useLocation();

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    if (document && document.scrollingElement) {
      document.scrollingElement.scrollTop = 0;
    }
    if (mainContent && mainContent.current) {
      //@ts-ignore
      mainContent.current.scrollTop = 0;
    }
  }, [location]);

  const getRoutes = (routes: any) => {
    return routes.map((prop: any, key: number) => {
      if (prop.layout === "/admin") {
        return (
          // @ts-ignore
          <Route path={prop.path} element={prop.component} key={key} exact />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <>
      <LogoutTimer />
      {location.pathname !== "/admin/sign-document" && (
        <Sidebar
          {...props}
          routes={routesOffice}
          logo={{
            innerLink: "/admin/index",
            imgSrc: require("../../assets/img/brand/logoendocpng.png"), // Use user photo or default logo
            imgAlt: "User Photo",
          }}
        />
      )}
      <div className="main-content" ref={mainContent}>
        <Routes>
          {getRoutes(routesOffice)}
          <Route
            path="*"
            element={<Navigate to="/admin/index" replace />}
          />{" "}
        </Routes>
        <Container fluid>
          <AdminFooter />
        </Container>
      </div>
    </>
  );
};

export default Admin;
